@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../constants/spacing.module.less';

.message-wrapper {
  font-size: 13px;
  flex-wrap: nowrap;
  .message-currency-code {
    font-weight: @bold;
  }
}

.icon {
  color: var(--gray-637381);
  padding-right: @space-8;
  &.warning {
    color: var(--gold-500);
  }

  &.error {
    color: var(--red-600);
  }
}
